import Routing from '../../core/router/router';
import { HTTP } from '../../core/http/http-common';

const state = {
  clientName: '',
  authToken: '',
  isSuperAdmin: false,
  permissions: {},
  useJitsi: false,
  showExportBtnArchived: false,
  idUser: '',
  diffusion: "all",
  defaultThumbnail: '',
  showModal: false,
};

const mutations = {
  setAuthToken(state, authToken) {
    state.authToken = authToken;
  },
  setIsSuperAdmin(state, isSuperAdmin) {
    state.isSuperAdmin = isSuperAdmin;
  },
  setPermissions(state, modules) {
    state.permissions = modules;
  },
  setIdUser(state, idUser) {
    state.idUser = idUser;
  },
  setClientName(state, clientName) {
    state.clientName = clientName;
  },
  setUseJitsi(state, useJitsi) {
    state.useJitsi = useJitsi;
  }, setShowExportBtnArchived(state, showExportBtnArchived) {
    state.showExportBtnArchived = showExportBtnArchived;
  },
  setDiffusion(state, diffusion) {
    state.diffusion = diffusion;
  },
  setDefaultThumbnail(state, defaultTumbnail) {
    state.defaultThumbnail = defaultTumbnail;
  },
  setShowModal(state, showModal) {
    state.showModal = showModal;
  }
};

const actions = {
  async getUserParams({ commit }, cryptext) {
    const url = Routing.generate('api_live_get_user_params', { cryptext });
    const { data } = await new Promise((resolve, reject) => {
      HTTP.get(url).then(response => {
        resolve(response);
      });
    });
    commit('setAuthToken', data.userData.auth_token);
    commit('setIsSuperAdmin', data.userData.isSuperAdmin);
    commit('setPermissions', data.userData.modules);
    commit('setIdUser', data.userData.idUser);
    commit('setClientName', data.client);
    commit('setDefaultThumbnail', data.defaultTumbnail);
    commit('setUseJitsi', data.use_jitsi);
    commit('setShowExportBtnArchived', data.show_export_btn_archived);
    commit('setDiffusion', data.diffusion);
    window.ApiToken = data.userData.auth_token;
    window.client = data.client;
  },
  setDiffusionLive({ commit }, val) {
    commit('setDiffusion', val);
  },
  setShowModal({ commit }, val) {
    commit('setShowModal', val);
  }
};

const getters = {
  getPermission: state => state.permissions,
  getSuperAdmin: state => state.isSuperAdmin,
  /* getSelected: state => state.selected,*/
  getUseJitsi: state => state.useJitsi,
  getShowExportBtnArchived: state => state.showExportBtnArchived,
  getDiffusion: state => state.diffusion,
  getUserName: state => state.clientName,
  getDefaultThumbnail: state => state.defaultThumbnail,
  hasPermission: state => permissions =>
    permissions.split(',').some(v => state.permissions[v]) || state.isSuperAdmin,
  getShowModal: state => state.showModal,
  getUserId: state => state.idUser,

};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/common-data.js